import { useEffect } from "react";
import "./Modal.css";
import { Modal } from "@iq/models";

function SelectProfile({ candidates = [], onSelectCandidate, onClose }) {
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose?.();
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <Modal 
        isOpen={true} 
        onClose={onClose} 
        overlayClassName="modal-backdrop" 
        title="Select your profile"
      >
        <div className="candidate-list">
          {candidates.length > 0 ? (
            candidates.map((candidate) => (
              <button
                key={candidate.id}
                type="button"
                className="candidate-row"
                onClick={() => onSelectCandidate?.(candidate)}
              >
                <span className="candidate-name">{candidate.name}</span>
                <span className="candidate-email">{candidate.email}</span>
              </button>
            ))
          ) : (
            <p className="modal-empty-state">No profiles were returned.</p>
          )}
        </div>
    </Modal>
  );
}

export default SelectProfile;